import React from 'react';
import { User, Sparkles } from 'lucide-react';

const ConversationPanel = ({ messages }) => {
  return (
    <div className="space-y-6">
      {messages?.map((message) => (
        <div
          key={message?.id}
          className={`flex gap-4 ${message?.type === 'user' ? 'justify-end' : 'justify-start'}`}
        >
          {message?.type === 'assistant' && (
            <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-blue-600 rounded-full flex items-center justify-center flex-shrink-0">
              <Sparkles className="w-4 h-4 text-white" />
            </div>
          )}
          
          <div
            className={`max-w-3xl rounded-lg px-4 py-3 ${
              message?.type === 'user' ?'bg-purple-600 text-white'
                : message?.isError
                ? 'bg-red-50 text-red-900 border border-red-200' :'bg-white border border-gray-200 text-gray-900'
            }`}
          >
            <p className="text-sm leading-relaxed whitespace-pre-wrap">{message?.content}</p>
            {message?.timestamp && (
              <p
                className={`text-xs mt-2 ${
                  message?.type === 'user' ? 'text-purple-200' : 'text-gray-400'
                }`}
              >
                {new Date(message.timestamp)?.toLocaleTimeString([], {
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </p>
            )}
          </div>

          {message?.type === 'user' && (
            <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
              <User className="w-4 h-4 text-gray-600" />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ConversationPanel;